<template>
  <window ref="window" size="md" title="Spezialwerkzeuge">
    <template slot-scope="{ data }">
      <ul>
        <li v-for="tool in data" :key="tool.id">
          {{ tool.name }}
        </li>
      </ul>
    </template>
  </window>
</template>

<script>
export default {
  provide: {
    windowId: "jobTools",
  },
};
</script>